/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class ChangeParentOrganizationConfimationModalContext {
  public isFrom!: string;
  public data?: any;
}

@Component({
  selector: 'app-change-parent-organization-confirmation-modal',
  templateUrl: './change-parent-organization-confirmation-modal.component.html',
  // styleUrls: ['./change-parent-organization-confirmation-modal.component.css']
  providers: [CommonService],
  encapsulation: ViewEncapsulation.None
})
export class ChangeParentOrganizationConfirmationModalComponent implements OnInit {
  @Input() context!: ChangeParentOrganizationConfimationModalContext;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  public param: any;
  public currentParentOrganization: any;
  public newOrganization: any;
  public genTypes: any = {};

  constructor(
    public bsModalRef: BsModalRef<ChangeParentOrganizationConfimationModalContext>,
    public commonService: CommonService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.param = {
      value: this.context.data.orgUnitLbl
    };
    this.currentParentOrganization = this.context.data.currentParentOrganization;
    this.newOrganization = this.context.data.newOrganization;
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public closeModalWindow() {
    this.closeModal.emit('closed');
    this.bsModalRef.hide();
  }

  public confirmChange() {
    this.closeModal.emit('confirmed');
    this.bsModalRef.hide();
  }
}
